<template>
  <div>
    <div class="row noprint">
      <div class="col-md-6">
        <label for="ckm">Molde Manual?</label> <input id="ckm" v-model="molde_manual" @change="MoldeManual" class="ckbox " type="checkbox">
      </div>
      <div class="col-md-6">
        <label for="cke">Molde Especial?</label> <input id="cke" v-model="molde_especial" class="ckbox" type="checkbox" @change="MoldeEspecial">
      </div>
    </div>
    <div  class="print-molde-manual" v-show="molde_manual" >MOLDE MANUAL :</div>
    <div v-if="molde_manual">
      <input class="form-control" type="text" placeholder="Digite o nome do Molde" v-model="entrada" style="font-size: 0.9rem ()" @focus="mostrar_lista = true">
      <div class="resultado-busca lista" v-show="mostrar_lista" :style="'height :'+ tamanho_lista +'px'">
       <table class="table table-sm table-striped table-hover tabela-resutado">
        <tbody >
          <!-- <tr id="linha-{{index}}"> -->
            <tr  v-for="item in resultado">
              <td @click="Selecionado(item)" >{{item.nome_molde}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <div class="btn btn-detalhe" v-on:click="detalheModelo">DETALHE</div> -->
    <div class="print-molde-especial" v-show="molde_especial">MOLDE ESPECIAL</div>
    <div v-if="!verificar || verificado_molde_especial || verificado_molde_manual" @click="verificado = !verificado" class="status" 
    v-html="verificado_molde_especial || verificado_molde_manual || verificado ? 'VERIFICADO' : 'VERIFICAR'"
    :class="[verificado_molde_especial || verificado_molde_manual || verificado ? 'verificado' : 'verificar']"></div>
  </div>
</template>


<script>


export default {
  name: 'TrocaMolde',
  data () {
    return {
      entrada:'',
      molde_manual:false,
      molde_especial:false,
      mostrar_lista: false,
      tamanho_lista: null,
      verificado: false,
      item_selecionado:{},
      tabela: JSON.parse(JSON.stringify(TabelaMoldes)),
      verificado_molde_especial:false,
      verificado_molde_manual:false

    }
  },
  props:["idpai", "modelo", "verificar"],
  computed:{
    resultado(){
      let self = this
      let result = self.tabela.filter(molde =>{
        return molde.nome_molde.toLowerCase().includes(self.entrada.toLowerCase())
      })
      if((result.length * 33) < 198){
        self.tamanho_lista = (result.length * 33)
      }else{
        self.tamanho_lista = 198
      }
      return result
    }

  },
  created: function () {

  },
  methods:{
    MoldeEspecial(){
      // console.log(this.molde_especial);
      this.molde_especial ? this.verificado_molde_especial = true : this.verificado_molde_especial = false
      this.$emit('molde-especial', [this.idpai, this.molde_especial])
    },
    MostrarInfo:function(){

    },
    MoldeManual(){
      this.molde_manual ? this.verificado_molde_manual = true : this.verificado_molde_manual = false
      if(!this.molde_manual){
        this.$emit('selecionado', [this.idpai,{}])
      } else{
        if(this.item_selecionado != {}){
          this.$emit('selecionado', [this.idpai,this.item_selecionado])
        }
      }
    },
    detalheModelo:function(){
      let index = this.idpai

      this.$store.commit('ITEM_LISTA_ATIVO', index)
      this.$store.commit('ATUALIZAR_TORAX', this.$store.state.lista_csv[index].torax)
      this.$store.commit('ATUALIZAR_CINTURA', this.$store.state.lista_csv[index].cintura)
      this.$store.commit('ATUALIZAR_QUADRIL', this.$store.state.lista_csv[index].quadril)
      this.$store.commit('ATUALIZAR_GANCHO', this.$store.state.lista_csv[index].gancho)


      this.$router.push({ name: 'Inicio'})

    },
    Selecionado(item){
      let modelo = this.modelo
      
      if(this.molde_manual){

        this.entrada = item.nome_molde
        this.mostrar_lista = false

      //CALCULAR AS DIFERENÇAS
      item.diferenca_torax = Math.abs(item.torax - modelo.torax)
      item.diferenca_cintura = Math.abs(item.cintura - modelo.cintura)
      item.diferenca_quadril = Math.abs(item.quadril - modelo.quadril)
      item.diferenca_gancho = Math.abs(item.gancho - modelo.gancho)
      item.soma_diferenca = item.diferenca_torax + item.diferenca_cintura + item.diferenca_quadril + item.diferenca_gancho

      let dados = [this.idpai, item] 

      // salvar item para caso marque e desmarque a caixa de seleção do molde manual, ver metodo do checkbox
      this.item_selecionado = item

      
      this.$emit('selecionado', dados)
    }else{
      this.$emit('selecionado', [this.idpai,{}])
    }
    this.molde_manual ? this.verificado_molde_manual = true : this.verificado_molde_manual = false
  }
}
}
</script>


<style scoped>
.print-molde-especial{
  position: relative;
  /*bottom: 5px;*/
  /*right: 5px;*/
  /*background-color: #00c785;*/
  color: #00c785;
  font-weight: 500;
  display: none;
  margin-top: 10px;
}
.print-molde-manual{
  position: relative;
  /*color: #00c785;*/
  font-weight: 500;
  display: none;
}
@media print { 
  .print-molde-manual{
    display: block;
  }
  .print-molde-especial{
    display: block;
  }
  .noprint { display:none; } 
}
.ckbox{
  width: 20px;
  height: 20px;
  position: relative;
  top: 4px;
  left: 4px;

  /*margin-left: 5px;*/
  /*margin-right: 15px;*/
}
.resultado-busca{
 position: absolute;
 background-color: white;
 z-index: 99;
 height: 198px;
 overflow: auto;

}
.lista{
  width: 90%;
}
.tabela-resutado{
  margin-bottom: 0px;
}
.status{
  position: absolute;
  bottom: 5px;
  right: 5px;
  cursor: pointer;
}
.verificado{
  padding: 5px;
  background-color: #00c785;
  color:white;
}
.verificar{
  padding: 5px;
  background-color: #f13b16;
  color:white;
}

.btn-detalhe{
  position: absolute;
  bottom: 5px;
  color: #83878a;
  background-color: #e6e6e6;
  border-color: #f8f9fa;
}
</style>



// WEBPACK FOOTER //
// src/components/partes/TrocaMolde.vue